import type { FC, SVGProps } from "react";
import { useTranslation } from "react-i18next";

import IconCheck from "images/icons/check.svg";
import IconClock from "images/icons/clock.svg";
import IconCross from "images/icons/close.svg";

import type { AnswerStatus } from "./answerStatus";

// SVG místo znaků ◷ ✓ ✕ z Figmy: znak sedí na účaří písma a v pilulce padal dolů. [TD-334]
const ICONS: Record<AnswerStatus, FC<SVGProps<SVGSVGElement>>> = {
  pending: IconClock,
  rejected: IconCross,
  accepted: IconCheck,
};

interface Props {
  status: AnswerStatus;
}

const AnswerStatusPill: FC<Props> = ({ status }) => {
  const { t } = useTranslation("unrecognizedAnswers");
  const Icon = ICONS[status];

  return (
    <span className={`answer-status-pill answer-status-pill--${status}`}>
      <Icon className="answer-status-pill__icon" aria-hidden="true" />
      {t(`status.${status}`)}
    </span>
  );
};

export default AnswerStatusPill;
